import MaterialTable from "@material-table/core";
import { Card } from "@mui/material";
import { db, useIsMounted } from "hooks";
import { useMessages } from "hooks/useDataFetch";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { muiTable } from "utils";

const ViewMessages = () => {
  const [sortedMessage, setSortedMessage] = useState([]);
  const { data, error, loading } = useMessages();
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted.current) {
      if (!data) return;
      const sortedMessage = [...data].sort((a, b) => {
        return moment(b.createdAt).diff(moment(a.createdAt));
      });
      setSortedMessage(sortedMessage);
    }
  }, [data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      const unreadMessage = sortedMessage?.filter((item) => {
        return item.read === false;
      });
      if (unreadMessage?.length) {
        unreadMessage.forEach(async (item) => {
          await db.updateDb(`/contactus/${item.id}`, {
            read: true,
          });
        });
      }
    }
  }, [sortedMessage, isMounted]);

  console.log(sortedMessage);

  return (
    <MaterialTable
      title="Messages"
      isLoading={!sortedMessage && loading}
      data={sortedMessage || []}
      options={{ ...muiTable.options() }}
      style={muiTable.styles}
      columns={[
        {
          title: "#",
          field: "sl",
          width: "5%",
          editable: "never",
        },
        {
          title: "Name",
          field: "name",
          width: "20%",
          editable: "never",
          emptyValue: "Not Provided",
        },
        {
          title: "Email",
          field: "email",
          width: "20%",
          editable: "never",
          emptyValue: "Not Provided",
        },
        {
          title: "Phone",
          field: "phone",
          width: "20%",
          editable: "never",
          emptyValue: "Not Provided",
        },
        {
          title: "Query Type",
          field: "queryType",
          width: "20%",
          editable: "never",
          emptyValue: "Not Provided",
        },
        {
          title: "Sent At",
          field: "createdAt",
          emptyValue: "Not Provided",
          render: (rowData) => {
            return moment(rowData?.createdAt).format("DD-MM-YYYY hh:mm:ss");
          },
        },
        {
          title: "Query",
          field: "message",
          width: "20%",
          editable: "never",
          emptyValue: "Not Provided",
        },
      ]}
    />
  );
};

export default ViewMessages;
